<template>
  <el-container class="home-wrap">
    <el-main v-if="!isSetting" class="full-content buy-table buy-table-setapp">
      <div class="setapp_time_limit flex-row-center">{{$t('Website Filter')}}
        <!-- <img style="margin-left: 12px;" @click="WebsiteTip" :src="$Image('tip.png')" alt=""> -->
      </div>
      <el-tabs v-loading="isloading" class="flex-col-start buy-header" v-model="activeName" type="card" @tab-click="handleClick">
        <!-- 网站过滤模块信息 -->
         <el-tab-pane label="Restriction" name="first" class="tab-pane-btn">
           <div class="flex-col-center buy-main">
             <div class="buy-main-y">
               <div v-for="(item, i) in SetWebFilterDatas" :key="i" class="setapp-mian">
                 <div class="setapp-mian-div">
                   <div class="app-main-note flex-row-center-start">
                     <img :src="$Image(item && item.type === false ? 'pre.png' : 'alw.png')" alt="">
                     <span>{{$t(item.name)}}</span>
                   </div>
                    <el-dropdown size="small" trigger="click" @visible-change="openPrevent(item)" @command="selectAllow">
                      <div class="flex-row-center">
                        <span :class="item.type === false ? 'dropdown_type' : 'dropdown_type_allow'" style="cursor:pointer;">
                          {{ item.type === false ? $t('Prevent') : $t('Allow')}}
                        </span>
                        <img style="margin-left: 12px;" :src="$Image('drop-down.png')" alt="">
                      </div>
                      <el-dropdown-menu slot="dropdown" class="languageSelect">
                        <el-dropdown-item v-for="(item, i) in dropdownList" :key="i" :command="item">
                          <div class="flex-row-start">
                            <span class="setting_Span">{{item}}</span>
                          </div>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                 </div>
               </div>
             </div>
           </div>
        </el-tab-pane>
        <!-- 例外网站 -->
         <el-tab-pane label="Exception" name="second" class="tab-pane-btn-b">
           <div class="flex-col-center buy-main">
             <div v-if="setException && setException.length > 0" class="buy-main-y">
               <div v-for="(item, i) in setException" :key="i" class="setapp-mian">
                 <div class="setapp-mian-div">
                   <div class="app-main-note flex-row-center-start">
                     <img :src="$Image(item && item.type === false ? 'pre.png' : 'alw.png')" alt="">
                     <span>{{item.name}}</span>
                   </div>
                   <div class="flex-row-end">
                      <span :class="item.type === false ? 'dropdown_type' : 'dropdown_type_allow'">
                        {{ item.type === false ? $t('Prevent') : $t('Allow')}}
                      </span>
                      <img style="margin-left: 12px;cursor:pointer;" @click="onDelete(item)" :src="$Image('delete.png')" alt="">
                    </div>
                 </div>
               </div>
             </div>
             <div v-else class="full-content flex-col-center">
                <img :src="$Image('wb_nd.png')" alt="">
                <p style="margin-top:38px;color: #777777;font-size: 18px;">{{$t('Customize site access: Prevent or Allow.')}}</p>
             </div>
            <div class="flex-row-center buy-footers">
              <el-button @click="onAddException" class="normalBtn buy-footer-btns">{{$t('Add Exception')}}
              </el-button>
            </div>
           </div>
        </el-tab-pane>
      </el-tabs>
    </el-main>
    <el-main v-else class="full-content buy-table buy-table-setapp">
        <AddException @onCancel="onCancel" @OnAddException="OnAddException"></AddException>
    </el-main>
    <!-- // 删除例外网站 弹框提醒 -->
    <el-dialog
      :visible.sync="SignoutShowDialog"
      title="Tips"
      :show-close = 'false'
      class="dialog-disconnect"
      style="border-radius: 20px;"
      center>
      <div class="flex-col-center demo--dialog-body"><span>{{$t('Are you sure you want to delete the filter settings ?')}}</span></div>
      <span slot="footer" class="dialog-footer demo-dialog-footer">
        <el-button class="delete-account-button" size="medium" round @click="SignoutShowDialog = false">{{$t('No')}}</el-button>
        <el-button class="delete-account-button" type="primary" round size="medium" @click="SignoutDialog">{{$t('Yes')}}</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>
<script>
import AddException from './AddException'
export default {
  name: 'website-filterp',
  props: ['userid', 'device'],
  data () {
    return {
      activeName: 'first',
      setException: [],
      dropdownList: ['Prevent', 'Allow'],
      WebFilterDatas: null,
      SignoutShowDialog: false,
      isSetting: false,
      SetWebFilterDatas: [],
      selectValue: null,
      isloading: false,
      SigDialog: null
    }
  },
  components: { AddException },
  methods: {
    // 网址过滤类别
    async getScreenAppLimit () {
      try {
        this.isloading = true
        const datas = await this.$http.get('MDM/GetWebFilter')
        this.WebFilterDatas = datas.data
        console.log(this.WebFilterDatas)
        let keys = Object.keys(this.WebFilterDatas)
        let values = Object.values(this.WebFilterDatas)
        if (keys.length !== 0) {
          this.SetWebFilterDatas = []
          for (let index = 0; index < keys.length; index++) {
            let objs = {}
            objs.name = keys[index]
            objs.type = values[index]
            this.SetWebFilterDatas.push(objs)
          }
        }
        this.isloading = false
      } catch (e) {
        console.log(e)
      }
    },
    // 例外网站列表
    async getWebException () {
      this.isloading = true
      const datas = await this.$http.get('MDM/GetWebFilterExpList')
      console.log(datas.data)
      let blacklists = datas.data.blacklist
      let whitelists = datas.data.whitelist
      this.setException = []
      for (let i = 0; i < blacklists.length; i++) {
        let objs = {}
        objs.name = blacklists[i]
        objs.type = false
        this.setException.push(objs)
      }
      for (let i = 0; i < whitelists.length; i++) {
        let objs = {}
        objs.name = whitelists[i]
        objs.type = true
        this.setException.push(objs)
      }
      this.isloading = false
    },
    handleClick (tab, event) {
    },
    // 获取单个选择的数据
    openPrevent (type) {
      this.selectValue = type
    },
    // 选择设置Allow或者Prevent
    async selectAllow (e) {
      if ((e === 'Allow' && this.selectValue.type === true) || (e === 'Prevent' && this.selectValue.type === false)) {
        console.log('不用改变')
      } else {
        this.SetWebFilterDatas.map((c) => {
          if (c.name === this.selectValue.name) {
            c.type = !c.type
          }
        })
        let obj = {}
        this.SetWebFilterDatas.forEach((c) => {
          obj[c.name] = c.type
        })
        // console.log(obj)
        const data = await this.$http.get('MDM/SetWebFilter', {
          params: {
            filterlist: obj
          }
        })
        console.log(data)
        this.getScreenAppLimit()
      }
    },
    // 进入添加例外网站组件 AddException
    onAddException () {
      this.isSetting = true
    },
    onCancel (t) {
      if (t === true) {
        this.isSetting = false
      }
    },
    // 添加例外网站逻辑
    async OnAddException (list, url) {
      this.isloading = true
      let parmas = {}
      if (list === false) {
        parmas = { blacklist: [url] }
      } else {
        parmas = { whitelist: [url] }
      }
      let formBody = new FormData()
      formBody.append('data', JSON.stringify(parmas))
      const datas = await this.$http.post('MDM/SetWebFilterExpList/Add', formBody)
      console.log(datas)
      this.isSetting = false
      this.getWebException()
      this.isloading = false
    },
    // 删除弹框提示SignoutShowDialog
    onDelete (item) {
      this.SigDialog = item
      this.SignoutShowDialog = true
    },
    // 确定删除 调删除接口
    async SignoutDialog () {
      let parmas = {}
      if (this.SigDialog.type === false) {
        parmas = { blacklist: [this.SigDialog.name] }
      } else {
        parmas = { whitelist: [this.SigDialog.name] }
      }
      let formBody = new FormData()
      formBody.append('data', JSON.stringify(parmas))
      const datas = await this.$http.post('MDM/SetWebFilterExpList/Delete', formBody)
      console.log(datas)
      this.SignoutShowDialog = false
      this.getWebException()
    },
    // 头部标题感叹号弹框提示
    WebsiteTip () {
      const h = this.$createElement
      this.$msgbox({
        customClass: 'message-WebsiteTip',
        message: h('h2', null, [
          h('p', { style: 'font-size: 20px;color: #333333;line-height: 30px;font-weight: normal;margin-bottom: 20px;margin-top:40px' }, this.$t('Filtering web browser access by category and URL')),
          h('p', { style: 'font-size: 18px;color: #333333;line-height: 30px;font-weight: normal;margin-bottom: 20px;' }, this.$t('（Only Chrome browser is supported）'))
        ]),
        confirmButtonText: this.$t('OK'),
        confirmButtonClass: 'Nolocation-btn',
        center: true,
        showClose: false
      }).then(() => {
      }).catch(() => {
      })
    }
  },
  mounted () {
    this.getScreenAppLimit()
    this.getWebException()
    console.log(this.$route.query.Setting)
    if (this.$route.query.Setting !== undefined) {
      this.isSetting = this.$route.query.Setting
    }
  },
  watch: {
    '$route' (to, from) {
      console.log(to, from)
      if (to.name === from.name) {
        this.getScreenAppLimit()
        this.getWebException()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-wrap{
  width:100%;
  height:92%;
  box-sizing: border-box;
  overflow: hidden;
  .buy-table{
    background-color: #ffffff;
    box-shadow: 4px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    height: 100%;
    overflow: hidden;
    .buy-header{
      width:100%;
      height:88%;
      box-sizing: border-box;
      color: #333333;
      font-size: 24px;
    }
    .buy-main{
      width: 100%;
      height: 100%;
      .nodata-found{
        font-size: 18px;font-weight: normal;line-height: 54px;color: #777777;margin-top: 20px;
      }
      .buy-main-y{
        overflow-y:scroll;width: 100%;height: 100%;
        .setapp-mian {
          padding-left: 3%;
          padding-right: 3%;
          .setapp-mian-div {
            padding-bottom: 2%;
            padding-top: 2%;
            padding-right: 2%;
            border-bottom: 1px solid #e7e7e7;
            display: -moz-box;  /* Firefox */
          display: -ms-flexbox;/* IE10 */
          display: -webkit-box;
          display: -webkit-flex;
          display: flex;flex-flow: row nowrap;justify-content: center;align-items: center;
          }
          .setapp-mian-div:hover {
            background-color: #f1faf7;
          }
        }
      }
    }
  }
}
.main-setapp{
  padding-left: 3%;
  padding-right: 5%;
}
.dropdown_type {
  font-size: 18px;color: #fd5955;
}
.dropdown_type_allow {
  color: #2bcf88;font-size: 18px;
}
.buy-footers{
  width:100%;
  height:9%;
  border-top:1px solid #e5e5e5;
  padding-top: 2%;
  padding-bottom: 2%;
  .buy-footer-btns{
    height:50px;width:14%;font-size:20px;
 }
}
.tab-pane-btn {
  height: 100%;
}
.tab-pane-btn-b {
  height: 100%;
}
.setapp_time_limit{
  font-size: 24px;
  color: #333333;
  padding: 2% 0;
}
.app-main-note span {
  font-size: 18px;color: #333333;padding-left: 20px;
}
.setting_Span{
  font-size: 16px;line-height: 36px;color: #888888;
}
@media (max-width: 1024px){
  .buy-footers .buy-footer-btns{
    height:50px;width:191px;
  }
  .setapp_time_limit {
    display: none;
  }
}
@media (max-width: 768px){
  .setapp_time_limit {
    font-size: 20px;
  }
  .home-wrap .buy-table .buy-main .buy-main-y .setapp-mian .setapp-mian-div{
    padding-bottom: 4%;
    padding-top: 4%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WebsiteFilter.vue